import React, { memo } from "react";
import {
  FormHelperText,
  TextField,
  TextFieldProps,
  Tooltip,
} from "@material-ui/core";
import useAppTextField from "./index.hooks";
import { InputLengthCounter } from "components/index";

export type AppTextFieldProps = {
  maxChars?: number;
  currentCount?: number;
  adornment?: React.ReactNode;
  noHelper?: boolean;
  tooltippedError?: boolean;
  hidden?: boolean;
} & TextFieldProps;

const AppTextField = ({
  maxChars,
  currentCount,
  error,
  adornment,
  helperText,
  noHelper,
  tooltippedError,
  hidden,
  ...props
}: AppTextFieldProps) => {
  const { styles, classes, atomicStyles } = useAppTextField();

  return (
    <div className={hidden ? styles.hidden : ""}>
      <Tooltip
        placement={"top"}
        title={helperText}
        disableTouchListener={!tooltippedError || !error}
        disableFocusListener={!tooltippedError || !error}
        disableHoverListener={!tooltippedError || !error}
        enterTouchDelay={1}
        arrow
      >
        <TextField
          error={error}
          {...props}
          InputProps={{
            startAdornment: adornment,
          }}
        />
      </Tooltip>
      {!noHelper && (
        <div className={styles.helperContainer}>
          {error && <FormHelperText error>{helperText}</FormHelperText>}
          {maxChars && currentCount >= 0 && (
            <div className={styles.charsCounter}>
              <InputLengthCounter
                maxChars={maxChars}
                currentCount={currentCount}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default memo(AppTextField);
